export default __webpack_public_path__ + "static/media/titleTokens.d85b2880.svg";